<wms-dialog id="diffEditorModal" customClasses="vcs-file-diff-dialog x-large">
    <wms-dialog-header (onClose)="closeCompareDiffModal()" title="{{locale['LABEL_VCS_COMPARE_DIFF']}}"
        helpTitle="{{locale['LABEL_VCS_COMPARE_DIFF']}}"
        helpLink="https://www.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#view-changes"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
        <wms-diff-editor *ngIf="vcsService.fileDiffResponse && vcsService.isTwoWayModalOpened"
            [diffFileContent]="vcsService.fileDiffResponse" [isTwoWay]="true"
            [isRevertAllowed]="!vcsService.isViewingDiffFromCommitHistory"
            [isReadOnly]="vcsService.isViewingDiffFromCommitHistory"></wms-diff-editor>
    </wms-dialog-body>
    <wms-dialog-footer>
        <div class="pull-right ng-scope">
            <button class="button-tertiary btn app-button" title="Cancel" (click)="closeCompareDiffModal()"
                *ngIf="!vcsService.isViewingDiffFromCommitHistory">
                <span class="btn-caption">Cancel</span></button>
          <ng-container *ngIf="!(this.vcsService.diffFileDetails?.vcsDiffType === 'ADDED'||this.vcsService.diffFileDetails?.vcsDiffType === 'DELETED') ">
            <button class="button-secondary btn app-button" name="wm-vcs-revert" title="Revert"
                (click)="revertDiffFile()" *ngIf="!vcsService.isViewingDiffFromCommitHistory "><span
                    class="btn-caption">Revert</span></button>
            <button class="button-primary btn app-button" title="Save" (click)="saveModifiedFile()"
                [disabled]="vcsService.isTwoWayModalOpened && vcsService.diffEditor?.editor().doc.isClean()"
                *ngIf="!vcsService.isViewingDiffFromCommitHistory  "><span class="btn-caption">Save</span></button>
          </ng-container>
            <button class="button-tertiary btn app-button" *ngIf="vcsService.isViewingDiffFromCommitHistory "
                title="Close" (click)="closeCompareDiffModal()">
                <span class="btn-caption">Close</span></button>
        </div>
    </wms-dialog-footer>
</wms-dialog>
